import { render, staticRenderFns } from "./longTengReconciliation.vue?vue&type=template&id=b488fd76&scoped=true"
import script from "./longTengReconciliation.vue?vue&type=script&lang=js"
export * from "./longTengReconciliation.vue?vue&type=script&lang=js"
import style0 from "./longTengReconciliation.vue?vue&type=style&index=0&id=b488fd76&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b488fd76",
  null
  
)

export default component.exports